import React from 'react';
import { useState, useEffect } from 'react';
import loader from './Images/SmcLoader.png';
import Calculator from './Calculator/Calculator';
import RetirementCalc from './Calculator/RetirementCalc';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaSortAmountDown, FaSortAmountUp } from "react-icons/fa";
import { Modal } from 'react-bootstrap';
import ShowSideError from "./UtilityComponents/ShowSideError";
import RetirementCalcDemo from './Calculator/RetirementCalcDemo';
import CompareInvestmentPlans from './Compare/CompareInvestmentPlans';
import WhyInvestNow from './Compare/WhyInvestNow';
import ShareQuotations from './ShareQuotations/ShareQuotations';
import ShareCode from './ShareCode/ShareCode';
import { isBeforeSep22_2025 } from './UtilityComponents/UtilityFunction';


const EnquiryDetails = ({ EnquiryNo, Quotes, LotNo, QuoteReq, HiddenQuotes, IsAscendingOrder, btnGST, handleGST, handleSort, IsQuoteLoading }) => {

    const [IsCalculator, setIsCalculator] = useState(false);
    const [CompareGPFDRD, setCompareGPFDRD] = useState(false);
    /*const [IsRetirementCalc, setIsRetirementCalc] = useState(false);*/
    const [IsRetirementCalcDemo, setIsRetirementCalcDemo] = useState(false);
    const [InvestNow, setInvestNow] = useState(false);
    const [isLoader, setLoader] = useState(true);
    const [IsShowSideError, setIsShowSideError] = useState(false);
    const [IsSuccess, setIsSuccess] = useState(false);
    const [ErrorMSG, setErrorMSG] = useState("");
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setLoader(Quotes.length > 0 ? false : true);
    }, [Quotes]);


    return (
        <>
            <section>
                <div className="useful-bar">
                    <div className="calculator-inline-block">
                        <div class="calculator-bar">
                            <button className="calculator-btn" onClick={() => setIsCalculator(true)}><span className="calc-btn-text">Calculators <i class="fas fa-chevron-right"></i></span></button>
                            <button className="calculator-btn" onClick={() => setCompareGPFDRD(true)}><span className="calc-btn-text">Compare Guaranteed Plan, FD & RD <i class="fas fa-chevron-right"></i></span></button>
                            {/*<button className="calculator-btn" onClick={() => setIsRetirementCalc(true)}><span className="calc-btn-text">Retirement Planning Calculator <i class="fas fa-chevron-right"></i></span></button>*/}
                            <button className="calculator-btn" onClick={() => setIsRetirementCalcDemo(true)}><span className="calc-btn-text">Retirement Planning Calculator <i class="fas fa-chevron-right"></i></span></button>
                        </div>

                        <Modal show={IsCalculator} className="CalculatorModal CalCssManager">
                            <Calculator QuoteReq={QuoteReq} Quotes={Quotes} close={() => setIsCalculator(false) } />
                        </Modal>

                        <Modal show={CompareGPFDRD} className="CalculatorModal Compare">
                            <CompareInvestmentPlans Quotes={Quotes} close={() => setCompareGPFDRD(false)} />
                        </Modal>

                        <Modal show={IsRetirementCalcDemo} className="CalculatorModal RetirementCalc">
                            <RetirementCalcDemo close={() => setIsRetirementCalcDemo(false)} />
                        </Modal>

                        <div className="question-bar">
                            <button className="question-btn" onClick={() => setInvestNow(true)}><img src={require("../Investment/Images/Lightened-Bulb.svg").default} alt="" /> <span className="calc-btn-text">Why Invest Now?</span></button>
                        </div>

                        <Modal show={InvestNow} className="CalculatorModal WhyInvestNow">
                            <WhyInvestNow EnquiryNo={EnquiryNo} close={() => setInvestNow(false)} />
                        </Modal>
                    </div>

                </div>
            </section>
            <section className="QuoteMiddleSec">
                <div className="PlanLeadQuotes" id="PlanLeadQuoteId">
                    <div className="">
                        <div className="d-flex">
                            <h3 className="PlanFounds mx-1">{IsQuoteLoading ? <img alt="" className="load" src={loader} /> : !isLoader && Quotes.map(row => row.NetPremium > 0)?.length} {Quotes.length === 1 ? "Plan Found" : IsQuoteLoading ? "Loading Plans" : Quotes.length === 0  ? "No Plan Found" : "Plans Found"} </h3> {Quotes.length > 0 && <div className="ShareQuotesWhatsapp">
                                <span onClick={() => setShowModal(true)}>
                                <i class="fas fa-share-alt"></i>
                                    <span className="ShareQuotes"></span></span>
                            {/* <button onClick={() => setShowModal(true)}>Share Quotes</button>*/}
                            {/*{!showModal && (<ShareCode showModal={showModal} EnquiryNo={EnquiryNo} LotNo={LotNo} MobileNo={QuoteReq.MobileNo} closeModal={() => setShowModal(false)} />)}*/}
                                {showModal && (<ShareQuotations showModal={showModal} HiddenQuotes={HiddenQuotes} EnquiryNo={EnquiryNo} LotNo={LotNo} MobileNo={QuoteReq.MobileNo} Email={QuoteReq?.EmailID ?? QuoteReq?.Email ?? ""} closeModal={() => setShowModal(false)} />)}

                        </div>}
                        </div>
                        <div className="d-flex">
                        {/*<p className="ExclusiveGst">Prices Exclusive of GST</p>*/}
                            <div className="EnquriryIdSize">
                                {/*<p>Lead ID: <strong className="ng-binding"><span id="EnqID">{EnquiryNo}&nbsp;<i className="far fa-copy"></i></span></strong></p>*/}
                                <p>
                                    <span>Lead ID:
                                        <strong className="ng-binding">
                                            <CopyToClipboard text={EnquiryNo}
                                                onCopy={() => {
                                                    /*this.setState({ IsShowSideError: true, IsSuccess: true, errorMSG: "Copied!!" });*/
                                                    setIsShowSideError(true);
                                                    setIsSuccess(true);
                                                    setErrorMSG("Copied!!");
                                                    setTimeout(() => {
                                                        setIsShowSideError(false);
                                                        setErrorMSG("Copied!!");
                                                    }, 2000)
                                                }}><span>{EnquiryNo}&nbsp;<i className="far fa-copy"></i></span>
                                            </CopyToClipboard>
                                        </strong>
                                    </span>
                                    {IsShowSideError &&
                                        <ShowSideError errorMSG={ErrorMSG} position="right" Isleft={false} IsSuccess={IsSuccess} show={IsShowSideError} />
                                    }
                                </p>
                            </div>
                        </div>
                    </div>

                    <div>                        
                        <div className="EnquriryIdSize">
                            {Quotes.length > 0 && < div className="share_Quotes">

                                {Quotes.length > 1 && <div className="SarQoute_Size2" onClick={()=>handleSort()}>
                                    Sort by Maturity {IsAscendingOrder ? <FaSortAmountDown className="React-Sort-Icon" style={{ color: '#30b524' }} /> : <FaSortAmountUp className="React-Sort-Icon" style={{ color: '#30b524' }} />}
                                </div>}
                                {isBeforeSep22_2025() && < div className="form-check form-switch gst_switch ENQ_box d-flex">
                                        <span className="text_gst  LeadID">Premium {btnGST ? "with" : "without"} GST</span>
                                    <label className="gst-toggle-label ms-2">
                                        <input className="form-check-input check_gst" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked={btnGST} onChange={(e) => handleGST(e)} />
                                    </label>
                                </div>}

                            </div>}
                        </div>

                    </div>

                </div>
            </section>
        </>
    );
}
export default EnquiryDetails;
